export default {
  init() {
    // JavaScript to be fired on all pages

  },
  finalize() {
    if(document.body.classList.contains('blog')) {
      require("@lottiefiles/lottie-player");
    }
  },
}